import { ModulesMap, ModulesConfigMap } from '@/config/data/modulesMaps'
import { _apiRequestWrap } from '../apiService'

function _getReportsServicePayments(options = {}) {
  return _apiRequestWrap(
    ModulesMap.REPORTS_SERVICE_PAYMENTS,
    ModulesConfigMap[ModulesMap.REPORTS_SERVICE_PAYMENTS].GET_REPORTS_SERVICE_PAYMENTS,
    options)
}

function _getReportsServicePayment(options = {}) {
  return _apiRequestWrap(ModulesMap.REPORTS_SERVICE_PAYMENTS, ModulesConfigMap[ModulesMap.REPORTS_SERVICE_PAYMENTS].GET_REPORTS_SERVICE_PAYMENT, options)

}
function _getReportsServicePaymentPreview(options = {}) {
  return _apiRequestWrap(ModulesMap.REPORTS_SERVICE_PAYMENTS, ModulesConfigMap[ModulesMap.REPORTS_SERVICE_PAYMENTS].GET_REPORTS_SERVICE_PAYMENT_PREVIEW, options)
}

export default {
  [ModulesConfigMap[ModulesMap.REPORTS_SERVICE_PAYMENTS].GET_REPORTS_SERVICE_PAYMENTS]: _getReportsServicePayments,
  [ModulesConfigMap[ModulesMap.REPORTS_SERVICE_PAYMENTS].GET_REPORTS_SERVICE_PAYMENT]: _getReportsServicePayment,
  [ModulesConfigMap[ModulesMap.REPORTS_SERVICE_PAYMENTS].GET_REPORTS_SERVICE_PAYMENT_PREVIEW]: _getReportsServicePaymentPreview,
}